const ApartmentStatusEnum = {
  NOT_HANDOVER: 1,
  HANDOVER: 2,
  OCCUPIED: 3,
  // NOT_RENTED: 4,
  // RENTED: 5
}
export default ApartmentStatusEnum


// WEBPACK FOOTER //
// ./src/enum/apartmentStatusEnum.js